/*
Controller: Images

Operations:
  createPresignedUrlForImages
  getImages
  uploadImage
  deleteImage
  getImage
*/
var Api = require('../config')
var CreatePresignedUrlRequestForSubmissionDef = require('../definitions/CreatePresignedUrlRequestForSubmission')
var ImageUploadRequestDef = require('../definitions/ImageUploadRequest')

var Images = (function () {
  /*
  Operation: createPresignedUrlForImages
  This accepts multiple MD5s in the request and returns presigned URLs for uploading the files.
  Parameters:
    submissionId: Id of the submission

  Responses:
    HTTP 200: Presigned URL for the provided MD5
    HTTP 400: md5 not valid.
    HTTP 403: Operation not permitted
  */
  function createPresignedUrlForImagesImages (submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        CreatePresignedUrlRequestForSubmissionDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions/{submissionId}/images/createPresignedUrl'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getImages
  Get all images metadata
  Parameters:
    submissionId: Id of the submission
  Responses:
    HTTP 200: Image found
    HTTP 403: Operation not permitted
    HTTP 404: Submission not found
  */
  function getImagesImages (submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/images'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: uploadImage
  Upload images to the platform
  Parameters:
    submissionId: Id of the submission

  Responses:
    HTTP 200: Successful upload
    HTTP 400: Upload failed
    HTTP 403: Operation not permitted
    HTTP 409: File has already been uploaded
    HTTP 413: Uploaded file too large
    HTTP 415: Wrong file type
  */
  function uploadImageImages (submissionId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
        ImageUploadRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/submissions/{submissionId}/images'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteImage
  Delete image
  Parameters:
    imageId: Id of image
    submissionId: Id of the submission
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete image
    HTTP 403: Operation not permitted
    HTTP 404: Image not found
  */
  function deleteImageImages (imageId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!imageId) {
          throw new Error('imageId: Missing parameter')
        }
        if (imageId && !(typeof imageId === 'string')) {
          throw new Error('imageId: Wrong type: Got "' + (typeof imageId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/images/{imageId}'
      path = path.replace('{' + 'imageId' + '}', imageId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getImage
  Get uploaded image file metadata
  Parameters:
    imageId: Id of image
    submissionId: Id of the submission
  Responses:
    HTTP 200: Image found
    HTTP 403: Operation not permitted
    HTTP 404: Image not found
  */
  function getImageImages (imageId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!imageId) {
          throw new Error('imageId: Missing parameter')
        }
        if (imageId && !(typeof imageId === 'string')) {
          throw new Error('imageId: Wrong type: Got "' + (typeof imageId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/submissions/{submissionId}/images/{imageId}'
      path = path.replace('{' + 'imageId' + '}', imageId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createPresignedUrlForImages'] = createPresignedUrlForImagesImages
  ret['getImages'] = getImagesImages
  ret['uploadImage'] = uploadImageImages
  ret['deleteImage'] = deleteImageImages
  ret['getImage'] = getImageImages
  return ret
})()

module.exports = Images
